import Page from '@elem/compPage/stream-series-plug-in-solar-battery/pages/product/StatusC/StreamAcPro';
import EfScrollAni from '@/efscrollani';

export default function Overview() {
    if (typeof window !== 'undefined') {
        if (!window?.AniContainer) {
            window.AniContainer = new EfScrollAni();
        }
    }
    return <Page />;
}
